import type { FunctionComponent, ReactNode } from 'react';

type KbdVariant = 'default' | 'hint';

const variantClasses: Record<KbdVariant, string> = {
  default: 'text-[10px] py-[2px] px-[5px] min-w-[16px] bg-bg-2 text-ink-2',
  hint: 'text-[9.5px] py-px px-1 mx-px min-w-[14px] bg-bg text-ink-3',
};

interface Props {
  variant?: KbdVariant;
  className?: string;
  children: ReactNode;
}

export const Kbd: FunctionComponent<Props> = ({ variant = 'default', className, children }) => {
  const base =
    'inline-flex items-center justify-center font-mono font-medium leading-none border border-line-2 border-b-[1.5px] rounded';
  return (
    <kbd className={[base, variantClasses[variant], className].filter(Boolean).join(' ')}>{children}</kbd>
  );
};
